export const I18N = {
  fr: {
    nav: {
      announce: "PARFUMS ARABES ROYAUX | FIDÈLES À LA SUNNA",
      shop: "Boutique",
      shopAll: "Toute la boutique",
      classics: "Classiques",
      blended: "Mélangés",
      fruity: "Fruité Tahara",
      story: "Notre Histoire",
      mission: "Mission Palestine",
      contact: "Contact",
      faq: "FAQ",
      badge: "25 % DES PROFITS → PALESTINE",
      cart: "Panier",
      menu: "Menu",
      close: "Fermer",
    },
    hero: {
      eyebrow: "أَرِيجُ المِسْكِ",
      line1: "L'essence du musc",
      line2: "arabe.",
      line3: "scellée dans l'or.",
      sub: "Des parfums intemporels inspirés de la tradition arabe. Découvrez votre signature olfactive avec ARIJ MISK.",
      ctaShop: "Voir toute la boutique",
      ctaMission: "Notre mission",
      bottle: "Flacon 10 ml",
    },
    marquee: {
      items: ["MUSC TAHARA", "MUSC BLANC", "MUSC NOIR", "MUSC À L'ORANGE", "MUSC AU OUD", "MISK AL SHOYOUKH", "MUSC DORÉ", "MUSC À LA LAVANDE", "MUSC TAHARA FRUITÉ", "MUSC TAHARA ANANAS", "MUSC À LA PÊCHE", "MUSC À LA FRAISE", "MUSC À LA VANILLE", "MUSC À LA ROSE"],
    },
    featured: {
      eyebrow: "En vedette",
      title: "Les signatures de la maison",
      sub: "Six flacons choisis pour entrer dans l'univers ARIJ MISK.",
      cta: "Voir toute la boutique",
    },
    family: {
      eyebrow: "La famille",
      title: "Les quatorze muscs, réunis",
      sub: "Quatorze essences disposées en escalier, montant des fruits gorgés de soleil vers les bois les plus précieux.",
      cta: "Explorer la boutique",
    },
    collections: {
      eyebrow: "Collections",
      title: "Explorer par collection",
      sub: "Trois familles olfactives, une même exigence de qualité.",
      classiques: { title: "Muscs Classiques", desc: "Tahara, Blanc, Noir, Shoyoukh et Doré — la tradition pure.", cta: "Voir la collection" },
      melanges: { title: "Parfums Mélangés", desc: "Orange, Oud, Lavande, Vanille, Rose et plus — des mariages raffinés.", cta: "Voir la collection" },
      fruite: { title: "Fruité Tahara", desc: "La douceur du tahara rencontre les fruits gorgés de soleil.", cta: "Voir la collection" },
    },
    storyTeaser: {
      eyebrow: "Notre histoire",
      title: "Un héritage arabe.\nUn parfum intemporel.",
      body: "ARIJ MISK s'inspire de la parfumerie arabe et des traditions du musc : des huiles précieuses, accessibles, fidèles à un héritage.",
      cta: "Découvrir notre histoire",
    },
    missionTeaser: {
      eyebrow: "Notre mission",
      title: "Plus qu'un parfum.\nUne grande cause.",
      body: "Notre mission : rendre accessibles des huiles de parfum et des attars de haute qualité à des prix raisonnables. Et parce qu'un parfum porte plus de sens : ARIJ MISK verse 25 % de tous ses profits pour soutenir la Palestine via le HDF (Human Development Fund).",
      cta: "Découvrir notre mission",
      stat: "25 %",
      statLabel: "de tous les profits sont versés pour soutenir la Palestine",
    },
    why: {
      eyebrow: "La maison",
      title: "Pourquoi ARIJ MISK ?",
      items: [
        "Huiles de parfum d'inspiration arabe",
        "Qualité premium à prix accessibles",
        "Flacons pratiques de 10 ml",
        "Un engagement sincère pour la Palestine",
      ],
    },
    newsletter: {
      title: "Soyez parmi les premiers à découvrir ARIJ MISK.",
      sub: "Rejoignez notre liste pour les nouveaux parfums, offres spéciales et actualités.",
      consent: "J'accepte de recevoir les courriels d'ARIJ MISK.",
      submit: "S'abonner",
      ok: "Merci ! Vous êtes inscrit à la liste ARIJ MISK.",
      err: "Une erreur est survenue. Réessayez.",
      emailPlaceholder: "Votre courriel",
    },
    pay: {
      secure: "Paiement sécurisé par carte — redirection vers notre page de paiement chiffrée.",
      successTitle: "Paiement confirmé. Merci !",
      successMsg: "Votre commande est confirmée et payée. Nous préparons votre colis avec soin et vous écrirons par courriel dès son expédition.",
      pending: "Nous confirmons votre paiement…",
      pendingLong: "Votre paiement a été reçu ; la confirmation prend quelques instants. Vous pouvez fermer cette page et revenir plus tard, votre commande est enregistrée.",
      cancelTitle: "Paiement annulé",
      cancelMsg: "Aucun montant n'a été prélevé. Votre panier est intact — vous pouvez reprendre quand vous voulez.",
      backToShop: "Retour à la boutique",
      notFound: "Session de paiement introuvable.",
    },
    shop: {
      eyebrow: "La boutique",
      title: "Les quatorze muscs",
      sub: "Quatorze huiles de parfum en flacons de 10 ml, trois collections, une même exigence.",
      all: "Tous",
      searchPlaceholder: "Rechercher un musc…",
      noResults: "Aucun résultat pour cette recherche.",
      sort: "Trier",
      sortFeatured: "En vedette",
      sortPriceAsc: "Prix croissant",
      sortPriceDesc: "Prix décroissant",
      sortAlpha: "Alphabétique",
      count: "parfums",
      inStock: "En stock · 10 ml",
      freeShip: "Achetez 3 bouteilles et profitez de la livraison gratuite.",
      empty: "Aucun parfum dans cette collection.",
    },
    product: {
      qty: "Quantité",
      add: "Ajouter au panier",
      freeShip: "Achetez 3 bouteilles et profitez de la livraison gratuite.",
      size: "Flacon de 10 ml",
      unisex: "Unisexe",
      notesTop: "Notes de tête",
      notesHeart: "Notes de cœur",
      notesBase: "Notes de fond",
      related: "Vous aimerez aussi",
      added: "Ajouté au panier",
    },
    cart: {
      title: "Votre panier",
      floating: "Panier",
      empty: "Votre panier est vide.",
      emptyCta: "Découvrir la boutique",
      subtotal: "Sous-total",
      each: "/ l'unité",
      shipping: "Livraison",
      destination: "Destination",
      destQc: "Québec",
      destRoc: "Reste du Canada",
      destUs: "États-Unis",
      destEu: "Europe",
      shipFree: "Offerte",
      freeFrom3: "Livraison gratuite dès 3 flacons, toutes destinations.",
      total: "Total",
      progress: (n) => (n === 1 ? "Plus qu'une bouteille pour la livraison gratuite !" : `Plus que ${n} bouteilles pour la livraison gratuite !`),
      unlocked: "Livraison gratuite débloquée !",
      checkout: "Passer à la caisse",
      name: "Nom complet",
      email: "Courriel",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "votre@courriel.ca",
      success: "Merci ! Votre commande a bien été reçue. Nous vous écrirons par courriel pour la confirmation et le paiement.",
      continue: "Continuer les achats",
      remove: "Supprimer",
      rates: "Tarifs fixes : Québec 5,75 $ · Reste du Canada 8,48 $ · États-Unis 11,00 $ · Europe 11,50 $",
      addrTitle: "Adresse de livraison",
      address: "Adresse",
      addressPlaceholder: "123, rue Exemple",
      apt: "Appartement, suite, etc. (facultatif)",
      city: "Ville",
      cityPlaceholder: "Votre ville",
      province: "Province / État",
      provincePlaceholder: "Province ou état",
      postal: "Code postal",
      postalPlaceholder: "Ex. H7W 4V4",
      phone: "Téléphone",
      phonePlaceholder: "+1 514 555 0123",
      country: "Pays / Destination",
      taxes: "Taxes — calculées au paiement",
    },
    story: {
      eyebrow: "Notre histoire",
      title: "Un héritage arabe.\nUn parfum intemporel.",
      lead: "ARIJ MISK s'inspire de la parfumerie arabe et des traditions du musc : des huiles précieuses, accessibles, fidèles à un héritage.",
      hadithTitle: "Paroles du Prophète — paix sur lui",
      h1: "Le meilleur des parfums est le musc.",
      h2: "Parmi les meilleurs de vos parfums figure le musc.",
      h3: "La purification est la moitié de la foi.",
      historyTitle: "Histoire du musc",
      timeline: [
        { t: "L'Antiquité", d: "Le musc figure parmi les parfums les plus précieux des routes commerciales d'Orient, apprécié des cours et des lieux de recueillement." },
        { t: "La tradition prophétique", d: "Dans la tradition musulmane, le bon parfum est encouragé ; le musc y occupe une place éminente." },
        { t: "Andalousie et Orient", d: "Des cours d'Andalousie aux souks du Moyen-Orient, les huiles parfumées se transmettent et se raffinent de génération en génération." },
        { t: "Aujourd'hui", d: "ARIJ MISK perpétue cet héritage : des huiles de parfum accessibles, fidèles à une tradition." },
      ],
      ctaMission: "Découvrir notre mission",
      ctaShop: "Voir la boutique",
    },
    mission: {
      eyebrow: "Notre mission",
      title: "Plus qu'un parfum.\nUne grande cause.",
      lead: "Notre mission est de rendre les huiles de parfum et les attars de haute qualité accessibles à prix raisonnables, afin que chacun puisse profiter de ces parfums intemporels tout en soutenant une cause humanitaire qui compte.",
      body: "ARIJ MISK s'engage à verser 25 % de tous ses profits pour soutenir la Palestine via le HDF (Human Development Fund).",
      notAffiliated: "Nous tenons à préciser qu'ARIJ MISK n'est pas affilié au HDF et n'a aucun partenariat officiel ni relation formelle avec cette organisation. Notre engagement de don est notre propre initiative, et nous souhaitons communiquer nos contributions en toute transparence.",
      stat: "25 %",
      statLabel: "de tous les profits sont versés pour soutenir la Palestine",
      via: "via le HDF (Human Development Fund)",
      calcTitle: "Comment le don est calculé",
      calc: "Le profit est calculé en soustrayant des revenus le coût des produits et des flacons, l'emballage, les frais de traitement des paiements et les autres dépenses d'affaires applicables. Le don correspond à 25 % du profit ainsi calculé — et non à 25 % du revenu total des ventes.",
      ctaShop: "Découvrir la boutique",
      valuesTitle: "Pourquoi ARIJ MISK ?",
    },
    contact: {
      eyebrow: "Contact",
      title: "Écrivez-nous",
      sub: "Une question sur un musc, une commande, la mission ? Nous vous répondons rapidement.",
      name: "Nom complet",
      email: "Courriel",
      category: "Sujet",
      catProduct: "Question sur un parfum",
      catOrder: "Commande",
      catMission: "Mission Palestine",
      catOther: "Autre",
      orderNumber: "Numéro de commande (facultatif)",
      message: "Message",
      namePlaceholder: "Votre nom",
      emailPlaceholder: "votre@courriel.ca",
      messagePlaceholder: "Votre message…",
      privacy: "Vos informations sont utilisées uniquement pour traiter votre demande. Voir notre politique de confidentialité.",
      submit: "Envoyer",
      ok: "Message envoyé ! Nous vous répondrons par courriel.",
      err: "Une erreur est survenue. Réessayez.",
      follow: "Suivez-nous",
      address: "4580 Promenade Paton, Unité 405, H7W 4V4",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Questions fréquentes",
      items: [
        { q: "Qu'est-ce que le musc ?", a: "Le musc est une matière parfumée emblématique de la parfumerie arabe, connue pour son sillage doux et profond. Nos muscs sont des huiles de parfum inspirées de cette tradition." },
        { q: "Qu'est-ce qu'une huile de parfum ?", a: "Une huile de parfum est une fragrance concentrée à appliquer directement sur la peau, où elle se révèle au fil des heures." },
        { q: "Quelle est la taille du flacon ?", a: "Chaque flacon ARIJ MISK contient 10 ml d'huile de parfum." },
        { q: "Comment utiliser l'huile de parfum ?", a: "Appliquez une petite quantité sur les points de pulsation — poignets, cou, derrière les oreilles." },
        { q: "Où ARIJ MISK livre-t-il ?", a: "Nous expédions au Canada (Québec et reste du Canada), aux États-Unis et en Europe. La disponibilité dépend de la destination et des restrictions d'expédition applicables. Consultez les options disponibles au moment de la commande." },
        { q: "Quels sont les frais d'expédition ?", a: "Tarifs fixes en dollars canadiens : Québec 5,75 $, reste du Canada 8,48 $, États-Unis 11,00 $, Europe 11,50 $. La livraison est offerte dès 3 flacons achetés, quelle que soit la destination." },
        { q: "Quelle est la politique de retour ?", a: "Vous pouvez demander un retour dans les 7 jours suivant la réception de votre commande. Consultez notre politique de retours et remboursements pour les détails." },
        { q: "Comment fonctionne l'initiative de don pour la Palestine ?", a: "ARIJ MISK verse 25 % de ses profits pour soutenir la Palestine via le HDF (Human Development Fund). Le profit est calculé après soustraction des coûts des produits, des flacons, de l'emballage, des frais de traitement des paiements et des autres dépenses d'affaires applicables." },
        { q: "Qu'est-ce que le HDF ?", a: "HDF signifie Human Development Fund, une organisation humanitaire qui soutient les personnes dans le besoin par des initiatives de développement et d'aide d'urgence. Son travail vise à aider les communautés vulnérables à accéder à un soutien essentiel et à améliorer leurs conditions de vie." },
        { q: "ARIJ MISK est-il partenaire du HDF ?", a: "Non. ARIJ MISK n'est pas affilié au HDF et n'a aucun partenariat officiel ni relation formelle avec cette organisation. Nous nous engageons de manière indépendante à verser une partie de nos profits au HDF pour soutenir les efforts humanitaires en Palestine." },
      ],
    },
    policies: {
      shipping: {
        title: "Politique de livraison",
        sections: [
          { h: "Destinations desservies", ps: ["ARIJ MISK livre au Canada (Québec et reste du Canada), aux États-Unis et en Europe uniquement. Aucune autre destination n'est desservie pour le moment."] },
          { h: "Tarifs d'expédition", ps: ["Les frais d'expédition sont fixes, en dollars canadiens (CAD) :", "Québec : 5,75 $ · Reste du Canada : 8,48 $ · États-Unis : 11,00 $ · Europe : 11,50 $", "La livraison est offerte pour toute commande de 3 flacons ou plus, quelle que soit la destination."] },
          { h: "Traitement et délais", ps: ["Les commandes sont préparées en 1 à 2 jours ouvrables. Le temps de traitement est distinct du temps d'expédition et de livraison.", "Les délais de livraison varient selon la destination et le transporteur ; aucune date de livraison n'est garantie."] },
          { h: "Douanes et frais d'importation", ps: ["Les expéditions vers les États-Unis et l'Europe peuvent être assujetties à des procédures douanières, à des droits de douane et à des taxes applicables, à la charge du destinataire."] },
          { h: "Restrictions", ps: ["L'éligibilité d'une destination dépend des restrictions applicables du transporteur et du pays de destination pour les huiles de parfum concentrées."] },
        ],
      },
      returns: {
        title: "Politique de retours et remboursements",
        sections: [
          { h: "Demande de retour", ps: ["Vous pouvez demander un retour dans les 7 jours suivant la réception de votre commande, en nous écrivant depuis la page Contact."] },
          { h: "Conditions", ps: ["Pour un retour motivé par un changement d'idée, le flacon doit être non ouvert et les frais de retour sont à votre charge.", "Si le parfum ne vous convient pas, le retour est accepté même si le flacon a été ouvert ; les mêmes délais s'appliquent."] },
          { h: "Produits endommagés ou défectueux", ps: ["Les produits endommagés ou défectueux sont traités séparément et équitablement, hors des conditions standard de changement d'idée. Écrivez-nous avec votre numéro de commande."] },
          { h: "Remboursements", ps: ["Une fois l'article retourné reçu et inspecté, le remboursement est émis selon le mode de paiement convenu au moment de votre commande."] },
          { h: "Droits des consommateurs", ps: ["Cette politique s'applique sans réduire les droits prévus par les lois applicables en matière de protection du consommateur."] },
        ],
      },
      "lost-package": {
        title: "Politique de colis perdu ou égaré",
        sections: [
          { h: "Colis présumé perdu", ps: ["Si votre commande semble perdue, nous ouvrons une recherche auprès du transporteur."] },
          { h: "Délai et suivi", ps: ["Un colis retardé n'est pas automatiquement considéré comme perdu. Nous faisons le suivi auprès du transporteur jusqu'à confirmation."] },
          { h: "Remplacement", ps: ["Lorsque la perte du colis est confirmée, nous envoyons un remplacement."] },
        ],
      },
      donation: {
        title: "Politique de don pour la Palestine",
        sections: [
          { h: "Notre engagement", ps: ["ARIJ MISK s'engage à verser 25 % de ses profits pour soutenir la Palestine via le HDF (Human Development Fund)."] },
          { h: "Calcul du profit", ps: ["Le profit est calculé en soustrayant des revenus le coût des produits et des flacons, l'emballage, les frais de traitement des paiements et les autres dépenses d'affaires applicables. Le don correspond à 25 % du profit ainsi calculé.", "Le don est établi sur le profit, et non sur le revenu total des ventes."] },
          { h: "Suivi et transparence", ps: ["Les transferts sont consignés dans nos registres. Aucune affirmation de don n'est publiée avant que le transfert ne soit effectivement complété."] },
          { h: "Indépendance", ps: ["ARIJ MISK n'est pas affilié au HDF et n'a aucun partenariat officiel ni relation formelle avec cette organisation. Notre engagement de don est notre propre initiative."] },
          { h: "Communications", ps: ["Les communications relatives aux dons ne constituent pas des reçus officiels de don de bienfaisance."] },
        ],
      },
      privacy: {
        title: "Politique de confidentialité",
        sections: [
          { h: "Informations recueillies", ps: ["Nous recueillons les informations nécessaires au traitement de votre commande : nom, courriel, adresse de livraison et contenu de votre commande.", "Votre courriel est utilisé si vous vous abonnez à notre liste d'information, avec votre consentement."] },
          { h: "Utilisation", ps: ["Vos informations servent au traitement des commandes et des paiements, à l'expédition et à la livraison, au service à la clientèle et au fonctionnement du site."] },
          { h: "Consentement courriel", ps: ["Vous pouvez retirer votre consentement aux courriels marketing en tout temps en nous écrivant."] },
          { h: "Vos droits", ps: ["Vous pouvez demander l'accès, la rectification ou la suppression de vos informations personnelles par la page Contact. Nous ne vendons pas vos renseignements personnels."] },
        ],
      },
      terms: {
        title: "Conditions d'utilisation",
        sections: [
          { h: "Généralités", ps: ["L'utilisation du site implique l'acceptation des présentes conditions. Le site présente des huiles de parfum ARIJ MISK en flacons de 10 ml, avec des prix en dollars canadiens (CAD)."] },
          { h: "Commandes", ps: ["Toute commande est sujette à acceptation et à confirmation. Le paiement est finalisé selon les modalités confirmées par courriel lors du traitement de votre commande."] },
          { h: "Prix et disponibilité", ps: ["Les prix et la disponibilité des produits peuvent être modifiés sans préavis, sauf indication contraire au moment de votre commande."] },
          { h: "Expédition et retours", ps: ["L'expédition est régie par la politique de livraison ; les retours, par la politique de retours et remboursements."] },
          { h: "Dons", ps: ["Les énoncés relatifs aux dons sont décrits dans la politique de don pour la Palestine."] },
          { h: "Limitation", ps: ["Les présentes conditions ne réduisent aucun droit obligatoire prévu par les lois applicables, notamment en matière de protection du consommateur."] },
        ],
      },
    },
    footer: {
      tagline: "Parfums arabes royaux.",
      rights: "© ARIJ MISK — TOUS DROITS RÉSERVÉS",
    },
    notFound: {
      title: "Page introuvable",
      cta: "Retour à l'accueil",
    },
  },
  en: {
    nav: {
      announce: "ROYAL ARABIAN FRAGRANCES | UPHOLDING THE SUNNAH",
      shop: "Shop",
      shopAll: "Shop All",
      classics: "Classic Musk",
      blended: "Blended Fragrances",
      fruity: "Fruity Tahara",
      story: "Our Story",
      mission: "Palestine Mission",
      contact: "Contact",
      faq: "FAQ",
      badge: "25% OF PROFITS → PALESTINE",
      cart: "Cart",
      menu: "Menu",
      close: "Close",
    },
    hero: {
      eyebrow: "أَرِيجُ المِسْكِ",
      line1: "The essence of",
      line2: "Arabian musk.",
      line3: "Sealed in gold.",
      sub: "Timeless fragrances inspired by Arabian tradition. Discover your signature scent with ARIJ MISK.",
      ctaShop: "Shop All Fragrances",
      ctaMission: "Our Mission",
      bottle: "10 ml bottle",
    },
    marquee: {
      items: ["MUSK TAHARA", "WHITE MUSK", "BLACK MUSK", "ORANGE MUSK", "OUD MUSK", "MISK AL SHOYOUKH", "GOLDEN MUSK", "LAVENDER MUSK", "MUSK TAHARA FRUITY", "MUSK TAHARA PINEAPPLE", "PEACH MUSK", "STRAWBERRY MUSK", "VANILLA MUSK", "ROSE MUSK"],
    },
    featured: {
      eyebrow: "Featured",
      title: "The house signatures",
      sub: "Six bottles chosen to enter the world of ARIJ MISK.",
      cta: "Shop All Fragrances",
    },
    family: {
      eyebrow: "The family",
      title: "The fourteen musks, together",
      sub: "Fourteen essences arranged like a staircase, rising from sun-drenched fruits to the most precious woods.",
      cta: "Explore the shop",
    },
    collections: {
      eyebrow: "Collections",
      title: "Explore by collection",
      sub: "Three olfactory families, one standard of quality.",
      classiques: { title: "Classic Musk", desc: "Tahara, White, Black, Shoyoukh and Golden — pure tradition.", cta: "Shop the collection" },
      melanges: { title: "Blended Fragrances", desc: "Orange, Oud, Lavender, Vanilla, Rose and more — refined marriages.", cta: "Shop the collection" },
      fruite: { title: "Fruity Tahara", desc: "The softness of tahara meets sun-drenched fruits.", cta: "Shop the collection" },
    },
    storyTeaser: {
      eyebrow: "Our story",
      title: "An Arabian heritage.\nA timeless fragrance.",
      body: "ARIJ MISK draws on Arabian perfumery and the traditions of musk: precious, accessible oils, true to a heritage.",
      cta: "Discover Our Story",
    },
    missionTeaser: {
      eyebrow: "Our mission",
      title: "More Than a Fragrance.\nA Greater Purpose.",
      body: "Our mission is to make high-quality perfume oils and attars accessible at reasonable prices. And because a fragrance carries more meaning: ARIJ MISK directs 25% of all profits to support Palestine through the HDF (Human Development Fund).",
      cta: "Discover Our Mission",
      stat: "25%",
      statLabel: "of all profits are given to support Palestine",
    },
    why: {
      eyebrow: "The house",
      title: "Why ARIJ MISK?",
      items: [
        "Arabian-inspired perfume oils",
        "Premium quality at accessible prices",
        "Handy 10 ml bottles",
        "A sincere commitment to Palestine",
      ],
    },
    newsletter: {
      title: "Be Among the First to Discover ARIJ MISK.",
      sub: "Join our mailing list for new fragrances, special offers, and brand updates.",
      consent: "I agree to receive emails from ARIJ MISK.",
      submit: "Subscribe",
      ok: "Thank you! You are on the ARIJ MISK list.",
      err: "Something went wrong. Please try again.",
      emailPlaceholder: "Your email",
      addrTitle: "Delivery address",
      address: "Address",
      addressPlaceholder: "123 Sample Street",
      apt: "Apartment, suite, etc. (optional)",
      city: "City",
      cityPlaceholder: "Your city",
      province: "Province / State",
      provincePlaceholder: "Province or state",
      postal: "Postal code",
      postalPlaceholder: "e.g. H7W 4V4",
    },
    pay: {
      secure: "Secure card payment — you will be redirected to our encrypted payment page.",
      successTitle: "Payment confirmed. Thank you!",
      successMsg: "Your order is confirmed and paid. We are carefully preparing your parcel and will email you as soon as it ships.",
      pending: "We are confirming your payment…",
      pendingLong: "Your payment was received; confirmation takes a few moments. You can close this page and come back later — your order is saved.",
      cancelTitle: "Payment cancelled",
      cancelMsg: "No amount was charged. Your cart is intact — you can pick up where you left off anytime.",
      backToShop: "Back to the shop",
      notFound: "Payment session not found.",
    },
    shop: {
      eyebrow: "The shop",
      title: "The fourteen musks",
      sub: "Fourteen perfume oils in 10 ml bottles, three collections, one standard.",
      all: "All",
      searchPlaceholder: "Search a musk…",
      noResults: "No results for this search.",
      sort: "Sort",
      sortFeatured: "Featured",
      sortPriceAsc: "Price: low to high",
      sortPriceDesc: "Price: high to low",
      sortAlpha: "Alphabetical",
      count: "fragrances",
      inStock: "In Stock · 10 ml",
      freeShip: "Buy any 3 bottles and get free shipping.",
      empty: "No fragrances in this collection.",
    },
    product: {
      qty: "Quantity",
      add: "Add to cart",
      freeShip: "Buy any 3 bottles and get free shipping.",
      size: "10 ml bottle",
      unisex: "Unisex",
      notesTop: "Top notes",
      notesHeart: "Heart notes",
      notesBase: "Base notes",
      related: "You will also like",
      added: "Added to cart",
    },
    cart: {
      title: "Your cart",
      floating: "Shopping Cart",
      empty: "Your cart is empty.",
      emptyCta: "Discover the shop",
      subtotal: "Subtotal",
      each: "/ each",
      shipping: "Shipping",
      destination: "Destination",
      destQc: "Quebec",
      destRoc: "Rest of Canada",
      destUs: "United States",
      destEu: "Europe",
      shipFree: "Free",
      freeFrom3: "Free shipping with 3 bottles or more, any destination.",
      total: "Total",
      progress: (n) => (n === 1 ? "One more bottle to unlock free shipping!" : `${n} more bottles to unlock free shipping!`),
      unlocked: "Free shipping unlocked!",
      checkout: "Proceed to Checkout",
      name: "Full name",
      email: "Email",
      namePlaceholder: "Your name",
      emailPlaceholder: "you@email.com",
      success: "Thank you! Your order has been received. We will email you to confirm and arrange payment.",
      continue: "Continue Shopping",
      remove: "Remove",
      rates: "Flat rates: Quebec $5.75 · Rest of Canada $8.48 · United States $11.00 · Europe $11.50",
    },
    story: {
      eyebrow: "Our story",
      title: "An Arabian heritage.\nA timeless fragrance.",
      lead: "ARIJ MISK draws on Arabian perfumery and the traditions of musk: precious, accessible oils, true to a heritage.",
      hadithTitle: "Words of the Prophet — peace be upon him",
      h1: "The best of perfumes is musk.",
      h2: "Among the best of your perfumes is musk.",
      h3: "Purification is half of faith.",
      historyTitle: "History of Musk",
      timeline: [
        { t: "Antiquity", d: "Musk stands among the most precious perfumes of the Eastern trade routes, cherished by courts and places of worship." },
        { t: "The Prophetic tradition", d: "In the Muslim tradition, good fragrance is encouraged; musk holds an eminent place in it." },
        { t: "Al-Andalus and the East", d: "From the courts of Andalusia to the souks of the Middle East, perfume oils have been passed on and refined from generation to generation." },
        { t: "Today", d: "ARIJ MISK carries on this heritage: accessible perfume oils, true to a tradition." },
      ],
      ctaMission: "Discover Our Mission",
      ctaShop: "Shop the fragrances",
    },
    mission: {
      eyebrow: "Our mission",
      title: "More Than a Fragrance.\nA Greater Purpose.",
      lead: "Our mission is to make high-quality perfume oils and attars accessible at reasonable prices, allowing more people to enjoy these timeless fragrances while supporting a meaningful humanitarian cause.",
      body: "ARIJ MISK is committed to directing 25% of all profits to support Palestine through the HDF (Human Development Fund).",
      notAffiliated: "We would like to clarify that ARIJ MISK is not affiliated with HDF and does not have an official partnership or formal relationship with the organization. Our commitment to donate is our own initiative, and we aim to communicate our contributions transparently.",
      stat: "25%",
      statLabel: "of all profits are given to support Palestine",
      via: "via the HDF (Human Development Fund)",
      calcTitle: "How the donation is calculated",
      calc: "Profit is calculated by subtracting the cost of the products and bottles, packaging, payment-processing fees, and other applicable business expenses from the revenue. The donation equals 25% of the resulting profit — not 25% of total sales revenue.",
      ctaShop: "Discover the shop",
      valuesTitle: "Why ARIJ MISK?",
    },
    contact: {
      eyebrow: "Contact",
      title: "Write to us",
      sub: "A question about a fragrance, an order, the mission? We answer quickly.",
      name: "Full name",
      email: "Email",
      category: "Subject",
      catProduct: "Question about a fragrance",
      catOrder: "Order",
      catMission: "Palestine Mission",
      catOther: "Other",
      orderNumber: "Order number (optional)",
      message: "Message",
      namePlaceholder: "Your name",
      emailPlaceholder: "you@email.com",
      messagePlaceholder: "Your message…",
      privacy: "Your information is used only to handle your request. See our privacy policy.",
      submit: "Send",
      ok: "Message sent! We will reply by email.",
      err: "Something went wrong. Please try again.",
      follow: "Follow us",
      address: "4580 Promenade Paton, Unit 405, H7W 4V4",
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently asked questions",
      items: [
        { q: "What is musk?", a: "Musk is an emblematic fragrant material of Arabian perfumery, known for its soft, deep trail. Our musks are perfume oils inspired by this tradition." },
        { q: "What is a perfume oil?", a: "A perfume oil is a concentrated fragrance applied directly to the skin, where it reveals itself over the hours." },
        { q: "What is the bottle size?", a: "Each ARIJ MISK bottle contains 10 ml of perfume oil." },
        { q: "How should the fragrance oil be used?", a: "Apply a small amount to pulse points — wrists, neck, behind the ears." },
        { q: "Where does ARIJ MISK ship?", a: "We ship to Canada (Quebec and rest of Canada), the United States and Europe. Availability depends on the destination and applicable shipping restrictions. Please check the available options when ordering." },
        { q: "What are the shipping charges?", a: "Flat rates in Canadian dollars: Quebec $5.75, rest of Canada $8.48, United States $11.00, Europe $11.50. Shipping is free with 3 bottles or more, any destination." },
        { q: "What is the return policy?", a: "You may request a return within 7 days of receiving your order. See our returns and refunds policy for details." },
        { q: "How does the Palestine donation initiative work?", a: "ARIJ MISK gives 25% of its profits to support Palestine through the HDF (Human Development Fund). Profit is calculated after subtracting product costs, bottle costs, packaging, payment-processing fees and other applicable business expenses." },
        { q: "What is HDF?", a: "HDF stands for Human Development Fund, a humanitarian organization focused on supporting people in need through development and relief initiatives. Its work aims to help vulnerable communities access essential support and improve their living conditions." },
        { q: "Is ARIJ MISK partnered with HDF?", a: "No. ARIJ MISK is not affiliated with HDF and does not have an official partnership or formal relationship with the organization. We independently commit to donating a portion of our profits to HDF to support humanitarian efforts for Palestine." },
      ],
    },
    policies: {
      shipping: {
        title: "Shipping Policy",
        sections: [
          { h: "Destinations served", ps: ["ARIJ MISK ships to Canada (Quebec and rest of Canada), the United States and Europe only. No other destination is served at this time."] },
          { h: "Shipping rates", ps: ["Shipping charges are flat rates in Canadian dollars (CAD):", "Quebec: $5.75 · Rest of Canada: $8.48 · United States: $11.00 · Europe: $11.50", "Shipping is free for any order of 3 bottles or more, whatever the destination."] },
          { h: "Processing and timing", ps: ["Orders are processed within 1–2 business days. Order-processing time is separate from shipping and delivery time.", "Delivery times vary by destination and carrier; no delivery date is guaranteed."] },
          { h: "Customs and import fees", ps: ["Shipments to the United States and Europe may be subject to customs procedures, duties and applicable taxes, payable by the recipient."] },
          { h: "Restrictions", ps: ["Destination eligibility depends on applicable carrier and destination-country restrictions for concentrated perfume oils."] },
        ],
      },
      returns: {
        title: "Returns and Refund Policy",
        sections: [
          { h: "Return requests", ps: ["You may request a return within 7 days of receiving your order by writing to us from the Contact page."] },
          { h: "Conditions", ps: ["For a change-of-mind return, the bottle must be unopened and return shipping costs are the customer's responsibility.", "If you do not like the scent, the return is accepted even though the bottle has been opened; the same time limits apply."] },
          { h: "Damaged or defective products", ps: ["Damaged or defective products are addressed separately and fairly, outside standard change-of-mind conditions. Write to us with your order number."] },
          { h: "Refunds", ps: ["Once the returned item is received and inspected, the refund is issued according to the payment method agreed when you placed your order."] },
          { h: "Consumer rights", ps: ["This policy applies without reducing rights provided by applicable consumer protection laws."] },
        ],
      },
      "lost-package": {
        title: "Lost or Missing Package Policy",
        sections: [
          { h: "Package presumed lost", ps: ["If your order appears to be lost, we open an investigation with the carrier."] },
          { h: "Delay and tracking", ps: ["A delayed shipment is not automatically considered lost. We follow up with the carrier until the outcome is confirmed."] },
          { h: "Replacement", ps: ["Once the package is confirmed lost, we send a replacement."] },
        ],
      },
      donation: {
        title: "Palestine Donation Policy",
        sections: [
          { h: "Our commitment", ps: ["ARIJ MISK commits to donating 25% of its profits to support Palestine through the HDF (Human Development Fund)."] },
          { h: "Profit calculation", ps: ["Profit is calculated by subtracting the cost of the products and bottles, packaging, payment-processing fees, and other applicable business expenses from the revenue. The donation equals 25% of the resulting profit.", "The donation is based on profit, not on total sales revenue."] },
          { h: "Tracking and transparency", ps: ["Transfers are recorded in our records. No donation claim is published before the transfer has actually been completed."] },
          { h: "Independence", ps: ["ARIJ MISK is not affiliated with HDF and does not have an official partnership or formal relationship with the organization. Our donation commitment is our own initiative."] },
          { h: "Communications", ps: ["Donation-related communications do not constitute official charitable tax receipts."] },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        sections: [
          { h: "Information collected", ps: ["We collect the information needed to process your order: name, email, shipping address and order contents.", "Your email is used if you subscribe to our mailing list, with your consent."] },
          { h: "Use", ps: ["Your information is used for order and payment processing, shipping and delivery, customer service, and website operation."] },
          { h: "Email consent", ps: ["You may withdraw your consent to marketing emails at any time by writing to us."] },
          { h: "Your rights", ps: ["You may request access, correction or deletion of your personal information through the Contact page. We do not sell personal information."] },
        ],
      },
      terms: {
        title: "Terms of Service",
        sections: [
          { h: "General", ps: ["Using the site implies acceptance of these terms. The site presents ARIJ MISK perfume oils in 10 ml bottles, with prices in Canadian dollars (CAD)."] },
          { h: "Orders", ps: ["Every order is subject to acceptance and confirmation. Payment is finalized according to the terms confirmed by email when we process your order."] },
          { h: "Prices and availability", ps: ["Prices and product availability may change without notice, unless stated otherwise at the time of your order."] },
          { h: "Shipping and returns", ps: ["Shipping is governed by the Shipping Policy; returns by the Returns and Refund Policy."] },
          { h: "Donations", ps: ["Donation statements are described in the Palestine Donation Policy."] },
          { h: "Limitation", ps: ["These terms do not reduce any mandatory rights provided by applicable laws, including consumer protection."] },
        ],
      },
    },
    footer: {
      tagline: "Royal Arabian fragrances.",
      rights: "© ARIJ MISK — ALL RIGHTS RESERVED",
    },
    notFound: {
      title: "Page not found",
      cta: "Back to home",
    },
  },
  ar: {
    nav: {
      announce: "عطور عربية ملكية | وفياً للسنة النبوية",
      shop: "المتجر",
      shopAll: "كل المتجر",
      classics: "الكلاسيكية",
      blended: "الخلطات",
      fruity: "طهارة بالفواكه",
      story: "قصتنا",
      mission: "مهمة فلسطين",
      contact: "اتصل بنا",
      faq: "الأسئلة الشائعة",
      badge: "25% من الأرباح → فلسطين",
      cart: "السلة",
      menu: "القائمة",
      close: "إغلاق",
    },
    hero: {
      eyebrow: "أَرِيجُ المِسْكِ",
      line1: "جوهرُ المسك",
      line2: "العربي.",
      line3: "مختومٌ بالذهب.",
      sub: "عطور خالدة مستوحاة من التقاليد العربية. اكتشف بصمتك العطرية مع أريج مسك.",
      ctaShop: "تسوّق كل العطور",
      ctaMission: "مهمتنا",
      bottle: "زجاجة 10 مل",
    },
    marquee: {
      items: ["مسك طهارة", "المسك الأبيض", "المسك الأسود", "مسك بالبرتقال", "مسك بالعود", "مسك الشيخ", "المسك الذهبي", "مسك باللافندر", "مسك طهارة بالفواكه", "مسك طهارة بالأناناس", "مسك بالخوخ", "مسك بالفراولة", "مسك بالفانيليا", "مسك بالورد"],
    },
    featured: {
      eyebrow: "مختارات",
      title: "توقيعات الدار",
      sub: "ست زجاجات مختارة للدخول إلى عالم أريج مسك.",
      cta: "تسوّق كل العطور",
    },
    family: {
      eyebrow: "العائلة",
      title: "أربعة عشر مسكاً مجتمعة",
      sub: "أربعة عشر عطراً مصفوفة على شكل درج، تصعد من الفواكه الاشتبكت بالشمس إلى الأخشاب الأثمن.",
      cta: "استكشف المتجر",
    },
    collections: {
      eyebrow: "المجموعات",
      title: "استكشف حسب المجموعة",
      sub: "ثلاث عائلات عطرية، ومعيار واحد للجودة.",
      classiques: { title: "المسك الكلاسيكي", desc: "طهارة، أبيض، أسود، شيوخ وذهبي — التقاليد الخالصة.", cta: "تسوّق المجموعة" },
      melanges: { title: "العطور الممزوجة", desc: "برتقال، عود، لافندر، فانيليا، ورد والمزيد — مزاوجات راقية.", cta: "تسوّق المجموعة" },
      fruite: { title: "طهارة بالفواكه", desc: "نعومة الطهارة تلتقي بالفواكه الاشتبكت بالشمس.", cta: "تسوّق المجموعة" },
    },
    storyTeaser: {
      eyebrow: "قصتنا",
      title: "إرثٌ عربي.\nعطرٌ خالد.",
      body: "يستلهم أريج مسك فن العطور العربية وتقاليد المسك: زيوت ثمينة، في متناول الجميع، وفية لإرث عريق.",
      cta: "اكتشف قصتنا",
    },
    missionTeaser: {
      eyebrow: "مهمتنا",
      title: "أكثر من عطر.\nقضية كبرى.",
      body: "مهمتنا: جعل زيوت العطور والعتّرات عالية الجودة في متناول الجميع بأسعار معقولة. ولأن العطر يحمل معنى أعمق: يخصص أريج مسك 25% من جميع أرباحه لدعم فلسطين عبر مؤسسة HDF للتنمية البشرية.",
      cta: "اكتشف مهمتنا",
      stat: "25 %",
      statLabel: "من جميع الأرباح تُخصص لدعم فلسطين",
    },
    why: {
      eyebrow: "الدار",
      title: "لماذا أريج مسك؟",
      items: [
        "زيوت عطرية مستوحاة من التراث العربي",
        "جودة فاخرة بأسعار في المتناول",
        "زجاجات عملية بحجم 10 مل",
        "التزام صادق تجاه فلسطين",
      ],
    },
    newsletter: {
      title: "كن من أوائل من يكتشفون أريج مسك.",
      sub: "انضم إلى قائمتنا لتصلك العطور الجديدة والعروض الخاصة والأخبار.",
      consent: "أوافق على استلام رسائل البريد الإلكتروني من أريج مسك.",
      submit: "اشترك",
      ok: "شكراً لك! أنت الآن في قائمة أريج مسك.",
      err: "حدث خطأ ما. حاول مرة أخرى.",
      emailPlaceholder: "بريدك الإلكتروني",
    },
    pay: {
      secure: "دفع آمن بالبطاقة — سيتم تحويلك إلى صفحة دفع مشفرة.",
      successTitle: "تم تأكيد الدفع. شكراً لك!",
      successMsg: "تم تأكيد طلبك ودفعُه. نحن نجهّز طردك بعناية وسنراسلك بالبريد الإلكتروني فور شحنه.",
      pending: "نؤكد عملية دفعك…",
      pendingLong: "تم استلام دفعتك؛ التأكيد يستغرق لحظات. يمكنك إغلاق الصفحة والعودة لاحقاً — طلبك محفوظ.",
      cancelTitle: "تم إلغاء الدفع",
      cancelMsg: "لم يُخصم أي مبلغ. سلتك كما هي — يمكنك المتابعة في أي وقت.",
      backToShop: "العودة إلى المتجر",
      notFound: "جلسة الدفع غير موجودة.",
    },
    shop: {
      eyebrow: "المتجر",
      title: "أربعة عشر مسكاً",
      sub: "أربعة عشر زيتاً عطرياً في زجاجات 10 مل، ثلاث مجموعات، معيار واحد.",
      all: "الكل",
      searchPlaceholder: "ابحث عن مسك…",
      noResults: "لا نتائج لهذا البحث.",
      sort: "ترتيب",
      sortFeatured: "المميزة",
      sortPriceAsc: "السعر: من الأقل إلى الأعلى",
      sortPriceDesc: "السعر: من الأعلى إلى الأقل",
      sortAlpha: "أبجدياً",
      count: "عطراً",
      inStock: "متوفر · 10 مل",
      quickView: "نظرة سريعة",
      size: "زجاجة 10 مل",
      freeShip: "اشترِ 3 زجاجات واحصل على التوصيل المجاني.",
      empty: "لا عطور في هذه المجموعة.",
    },
    product: {
      qty: "الكمية",
      add: "أضف إلى السلة",
      freeShip: "اشترِ 3 زجاجات واحصل على التوصيل المجاني.",
      size: "زجاجة رول أون 10 مل",
      unisex: "للجنسين",
      notesTop: "المقدمة العطرية",
      notesHeart: "قلب العطر",
      notesBase: "القاعدة العطرية",
      related: "سيعجبك أيضاً",
      added: "أُضيف إلى السلة",
    },
    cart: {
      title: "سلتك",
      floating: "سلة التسوق",
      empty: "سلتك فارغة.",
      emptyCta: "اكتشف المتجر",
      subtotal: "المجموع الفرعي",
      each: "/ للوحدة",
      shipping: "التوصيل",
      destination: "الوجهة",
      destQc: "كيبك",
      destRoc: "بقية كندا",
      destUs: "الولايات المتحدة",
      destEu: "أوروبا",
      shipFree: "مجاني",
      freeFrom3: "التوصيل مجاني من 3 زجاجات، لجميع الوجهات.",
      total: "الإجمالي",
      progress: (n) => (n === 1 ? "بقيت زجاجة واحدة للحصول على التوصيل المجاني!" : n === 2 ? "بقيت زجاجتان للحصول على التوصيل المجاني!" : `تبقّى ${n} زجاجات للحصول على التوصيل المجاني!`),
      unlocked: "تم تفعيل التوصيل المجاني!",
      checkout: "إتمام الطلب",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      namePlaceholder: "اسمك",
      emailPlaceholder: "you@email.com",
      success: "شكراً! تم استلام طلبك. سنراسلك بالبريد الإلكتروني للتأكيد وترتيب الدفع.",
      continue: "مواصلة التسوق",
      remove: "إزالة",
      rates: "أسعار ثابتة: كيبك 5.75 $ · بقية كندا 8.48 $ · الولايات المتحدة 11.00 $ · أوروبا 11.50 $",
      addrTitle: "عنوان التوصيل",
      address: "العنوان",
      addressPlaceholder: "123 شارع المثال",
      apt: "شقة، جناح، إلخ (اختياري)",
      city: "المدينة",
      cityPlaceholder: "مدينتك",
      province: "المقاطعة / الولاية",
      provincePlaceholder: "المقاطعة أو الولاية",
      postal: "الرمز البريدي",
      postalPlaceholder: "مثال H7W 4V4",
      phone: "الهاتف",
      phonePlaceholder: "+1 514 555 0123",
      country: "البلد / الوجهة",
      taxes: "الضرائب — تُحسب عند الدفع",
    },
    story: {
      eyebrow: "قصتنا",
      title: "إرثٌ عربي.\nعطرٌ خالد.",
      lead: "يستلهم أريج مسك فن العطور العربية وتقاليد المسك: زيوت ثمينة، في متناول الجميع، وفية لإرث عريق.",
      hadithTitle: "أحاديث النبي — صلى الله عليه وسلم",
      h1: "أَطْيَبُ الطِّيبِ الْمِسْكُ",
      h2: "مِنْ خَيْرِ طِيبِكُمْ الْمِسْكُ",
      h3: "الطُّهُورُ شَطْرُ الْإِيمَانِ",
      historyTitle: "تاريخ المسك",
      timeline: [
        { t: "العصور القديمة", d: "يُعدّ المسك من أثمن العطور في طرق التجارة الشرقية، وقد أُكترم في البلاطات ودور العبادة." },
        { t: "السنة النبوية", d: "في التقاليد الإسلامية يُستحبّ الطيب، ويحتل المسك مكانة سامية." },
        { t: "الأندلس والمشرق", d: "من بلاطات الأندلس إلى أسواق الشرق الأوسط، توارثت الأجيال الزيوت العطرية وصقلتها جيلاً بعد جيل." },
        { t: "اليوم", d: "يواصل أريج مسك إرثه هذا: زيوت عطرية في المتناول، وفية للتقاليد." },
      ],
      ctaMission: "اكتشف مهمتنا",
      ctaShop: "تسوّق العطور",
    },
    mission: {
      eyebrow: "مهمتنا",
      title: "أكثر من عطر.\nقضية كبرى.",
      lead: "مهمتنا هي جعل زيوت العطور والعتّرات عالية الجودة في متناول الجميع بأسعار معقولة، ليستطيع الجميع الاستمتاع بهذه العطور الخالدة مع دعم قضية إنسانية معنوية.",
      body: "يلتزم أريج مسك بتخصيص 25% من جميع أرباحه لدعم فلسطين عبر مؤسسة HDF للتنمية البشرية (Human Development Fund).",
      notAffiliated: "نودّ التوضيح أن أريج مسك غير منتسب إلى مؤسسة HDF وليس لديه أي شراكة رسمية أو علاقة رسمية بها. التزامنا بالتبرع مبادرة خاصة بنا، ونسعى للإفصاح عن مساهماتنا بشفافية.",
      stat: "25 %",
      statLabel: "من جميع الأرباح تُخصص لدعم فلسطين",
      via: "عبر مؤسسة HDF (Human Development Fund)",
      calcTitle: "كيف يُحسب التبرع",
      calc: "يُحسب الربح بطرح تكلفة المنتجات والزجاجات والتغليف ورسوم معالجة الدفعات وغيرها من مصاريف الأعمال المطبقة من الإيرادات. يبلغ قيمة التبرع 25% من الربح المحسوب — وليس 25% من إجمالي إيرادات المبيعات.",
      ctaShop: "اكتشف المتجر",
      valuesTitle: "لماذا أريج مسك؟",
    },
    contact: {
      eyebrow: "اتصل بنا",
      title: "راسلونا",
      sub: "سؤال عن مسك، عن طلب، عن المهمة؟ نرد عليك بسرعة.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      category: "الموضوع",
      catProduct: "سؤال عن عطر",
      catOrder: "طلب",
      catMission: "مهمة فلسطين",
      catOther: "أخرى",
      orderNumber: "رقم الطلب (اختياري)",
      message: "الرسالة",
      namePlaceholder: "اسمك",
      emailPlaceholder: "you@email.com",
      messagePlaceholder: "رسالتك…",
      privacy: "تُستخدم معلوماتك فقط لمعالجة طلبك. راجع سياسة الخصوصية.",
      submit: "إرسال",
      ok: "أُرسلت الرسالة! سنرد عليك بالبريد الإلكتروني.",
      err: "حدث خطأ ما. حاول مرة أخرى.",
      follow: "تابعنا",
      address: "4580 Promenade Paton, Unité 405, H7W 4V4",
    },
    faq: {
      eyebrow: "الأسئلة الشائعة",
      title: "أسئلة متكررة",
      items: [
        { q: "ما هو المسك؟", a: "المسك مادة عطرية أيقونية في العطور العربية، يُعرف بأثره العطري الناعم والعميق. مسكاتنا زيوت عطرية مستوحاة من هذا التقليد." },
        { q: "ما هو زيت العطر؟", a: "زيت العطر عطر مركّب يُوضع مباشرة على الجلد، ليكشف عن نفسه على مدى الساعات." },
        { q: "ما هو حجم الزجاجة؟", a: "تحتوي كل زجاجة من أريج مسك على 10 مل من زيت العطر." },
        { q: "كيف يُستخدم زيت العطر؟", a: "ضع كمية صغيرة على نقاط النبض — المعصمان، الرقبة، خلف الأذنين." },
        { q: "إلى أين تشحن أريج مسك؟", a: "نشحن إلى كندا (كيبك وبقية كندا) والولايات المتحدة وأوروبا. يعتمد التوفر على الوجهة وقيود الشحن المطبقة. تحقق من الخيارات المتاحة عند الطلب." },
        { q: "ما هي رسوم الشحن؟", a: "أسعار ثابتة بالدولار الكندي: كيبك 5.75 $، بقية كندا 8.48 $، الولايات المتحدة 11.00 $، أوروبا 11.50 $. التوصيل مجاني مع 3 زجاجات أو أكثر، لجميع الوجهات." },
        { q: "ما هي سياسة الإرجاع؟", a: "يمكنك طلب إرجاع خلال 7 أيام من استلام طلبك. راجع سياسة الإرجاع والاسترداد للتفاصيل." },
        { q: "كيف تعمل مبادرة التبرع لفلسطين؟", a: "يخصص أريج مسك 25% من أرباحه لدعم فلسطين عبر مؤسسة HDF للتنمية البشرية. يُحسب الربح بعد خصم تكاليف المنتجات والزجاجات والتغليف ورسوم معالجة الدفعات وغيرها من مصاريف الأعمال المطبقة." },
        { q: "ما هي HDF؟", a: "HDF اختصار Human Development Fund، منظمة إنسانية تركز على دعم المحتاجين من خلال مبادرات التنمية والإغاثة. يهدف عملها إلى مساعدة المجتمعات الضعيفة على الوصول إلى الدعم الأساسي وتحسين ظروف حياتها." },
        { q: "هل لدى أريج مسك شراكة مع HDF؟", a: "لا. أريج مسك غير منتسب إلى HDF وليس لديه أي شراكة رسمية أو علاقة رسمية بالمنظمة. نلتزم بشكل مستقل بالتبرع بجزء من أرباحنا إلى HDF لدعم الجهود الإنسانية من أجل فلسطين." },
      ],
    },
    policies: {
      shipping: {
        title: "سياسة التوصيل",
        sections: [
          { h: "الوجهات المخدومة", ps: ["يشحن أريج مسك إلى كندا (كيبك وبقية كندا) والولايات المتحدة وأوروبا فقط. لا تُخدم وجهات أخرى في الوقت الحالي."] },
          { h: "أسعار الشحن", ps: ["رسوم الشحن أسعار ثابتة بالدولار الكندي (CAD):", "كيبك: 5.75 $ · بقية كندا: 8.48 $ · الولايات المتحدة: 11.00 $ · أوروبا: 11.50 $", "التوصيل مجاني لأي طلب من 3 زجاجات أو أكثر، أياً كانت الوجهة."] },
          { h: "المعالجة والمواعيد", ps: ["تُجهَّز الطلبات خلال 1-2 يوم عمل. زمن المعالجة منفصل عن زمن الشحن والتوصيل.", "تختلف مواعيد التوصيل حسب الوجهة وشركة الشحن؛ ولا يُضمن أي موعد للتوصيل."] },
          { h: "الجمارك ورسوم الاستيراد", ps: ["قد تخضع الشحنات إلى الولايات المتحدة وأوروبا لإجراءات جمركية ورسوم وضرائب مطبقة، على حساب المُستلم."] },
          { h: "القيود", ps: ["يعتمد أهلية الوجهة على قيود شركة الشحن وقيود بلد الوجهة المطبقة على زيوت العطور المركّزة."] },
        ],
      },
      returns: {
        title: "سياسة الإرجاع والاسترداد",
        sections: [
          { h: "طلبات الإرجاع", ps: ["يمكنك طلب إرجاع خلال 7 أيام من استلام طلبك بمراسلتنا من صفحة اتصل بنا."] },
          { h: "الشروط", ps: ["للإرجاع بسبب تغيير الرأي، يجب أن تكون الزجاجة غير مفتوحة وتكون تكاليف الإرجاع على عاتق العميل.", "إذا لم يعجبك العطر، يُقبل الإرجاع حتى لو كانت الزجاجة قد فُتحت؛ وتنطبق المدد نفسها."] },
          { h: "المنتجات التالفة أو المعيبة", ps: ["تُعالج المنتجات التالفة أو المعيبة بشكل منفصل وعادل، خارج شروط تغيير الرأي القياسية. راسلنا مع رقم طلبك."] },
          { h: "الاسترداد", ps: ["بمجرد استلام العنصر المرتجع وفحصه، يُصدر الاسترداد وفق طريقة الدفع المتفق عليها عند تقديم الطلب."] },
          { h: "حقوق المستهلك", ps: ["تنطبق هذه السياسة دون تقليل الحقوق المنصوص عليها في قوانين حماية المستهلك المطبقة."] },
        ],
      },
      "lost-package": {
        title: "سياسة الطرد المفقود",
        sections: [
          { h: "طرد يُفترض فقدانه", ps: ["إذا بدا طلبك مفقوداً، نفتح تحقيقاً مع شركة الشحن."] },
          { h: "التأخير والمتابعة", ps: ["الشحنة المتأخرة لا تُعتبر تلقائياً مفقودة. نتابع مع شركة الشحن حتى تأكيد النتيجة."] },
          { h: "الاستبدال", ps: ["عند تأكيد فقدان الطرد، نرسل بديلاً."] },
        ],
      },
      donation: {
        title: "سياسة التبرع لفلسطين",
        sections: [
          { h: "التزامنا", ps: ["يلتزم أريج مسك بالتبرع بـ 25% من أرباحه لدعم فلسطين عبر مؤسسة HDF للتنمية البشرية (Human Development Fund)."] },
          { h: "حساب الربح", ps: ["يُحسب الربح بطرح تكلفة المنتجات والزجاجات والتغليف ورسوم معالجة الدفعات وغيرها من مصاريف الأعمال المطبقة من الإيرادات. يبلغ قيمة التبرع 25% من الربح المحسوب.", "يُحتسب التبرع على الربح، وليس على إجمالي إيرادات المبيعات."] },
          { h: "المتابعة والشفافية", ps: ["تُسجّل التحويلات في سجلاتنا. لا يُنشر أي إقرار بالتبرع قبل إتمام التحويل فعلياً."] },
          { h: "الاستقلالية", ps: ["أريج مسك غير منتسب إلى HDF وليس لديه أي شراكة رسمية أو علاقة رسمية بالمنظمة. التزامنا بالتبرع مبادرة خاصة بنا."] },
          { h: "المراسلات", ps: ["المراسلات المتعلقة بالتبرعات لا تُعد إيصالات تبرع خيرية رسمية."] },
        ],
      },
      privacy: {
        title: "سياسة الخصوصية",
        sections: [
          { h: "المعلومات المُجمّعة", ps: ["نجمع المعلومات اللازمة لمعالجة طلبك: الاسم، البريد الإلكتروني، عنوان التوصيل ومحتوى الطلب.", "يُستخدم بريدك الإلكتروني إذا اشتركت في قائمتنا البريدية، بموافقتك."] },
          { h: "الاستخدام", ps: ["تُستخدم معلوماتك لمعالجة الطلبات والمدفوعات، والشحن والتوصيل، وخدمة العملاء، وتشغيل الموقع."] },
          { h: "الموافقة البريدية", ps: ["يمكنك سحب موافقتك على رسائل التسويق في أي وقت بمراسلتنا."] },
          { h: "حقوقك", ps: ["يمكنك طلب الوصول إلى معلوماتك الشخصية أو تصحيحها أو حذفها عبر صفحة اتصل بنا. نحن لا نبيع معلوماتك الشخصية."] },
        ],
      },
      terms: {
        title: "شروط الخدمة",
        sections: [
          { h: "عام", ps: ["ي entails استخدام الموقع قبول هذه الشروط. يعرض الموقع زيوت العطور أريج مسك في زجاجات 10 مل، بأسعار بالدولار الكندي (CAD)."] },
          { h: "الطلبات", ps: ["كل طلب خاضع للقبول والتأكيد. يُتم الدفع وفق الشروط المؤكدة بالبريد الإلكتروني عند معالجة طلبك."] },
          { h: "الأسعار والتوفر", ps: ["قد تتغير الأسعار وتوفر المنتجات دون إشعار، ما لم يُذكر خلاف ذلك عند تقديم طلبك."] },
          { h: "الشحن والإرجاع", ps: ["يخضع الشحن لسياسة التوصيل؛ والإرجاع لسياسة الإرجاع والاسترداد."] },
          { h: "التبرعات", ps: ["التصريحات المتعلقة بالتبرعات موصوفة في سياسة التبرع لفلسطين."] },
          { h: "الحدود", ps: ["لا تقلل هذه الشروط أي حق إلزامي منصوص عليه في القوانين المطبقة، بما في ذلك حماية المستهلك."] },
        ],
      },
    },
    footer: {
      tagline: "عطور عربية ملكية.",
      rights: "© ARIJ MISK — جميع الحقوق محفوظة",
    },
    notFound: {
      title: "الصفحة غير موجودة",
      cta: "العودة إلى الرئيسية",
    },
  },
};
